import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getFromKey } from '../../services/message-filters';
import '../../styles/main.scss';
import './button-minihub.scss';
import MenuMinihub from '../menu-minihub/menu-minihub';


export function ButtonFilter(props) {
  const { t } = useTranslation();
  const [dialogVisible, setDialogVisible] = React.useState(false);
  const { application } = props;

  return (
    <span
      className={`button-filter icon-user-space mdc-menu-surface--anchor`}
      isotip={t('mainBar.quickModules')}
      isotip-position='bottom-end'
      isotip-size='small'
      isotip-hidden={dialogVisible.toString()}>
      {window.location === window.parent.location &&
        <MenuMinihub
          fullName={(application && application.user && application.user.credentials && application.user.credentials.name) ? application.user.credentials.name : ""}
          onToggleDialog={v => setDialogVisible(v)}
        />
      }
    </span>
  );
}

const mapStateToProps = state => ({
  activeMessageFilter: getFromKey(state.application.messageFilterKey),
  application: state.application
});

export default connect(mapStateToProps)(ButtonFilter);
